stream = {
    isStreamPlaying: false,
    streamEventSport: 0,
    streamEventRegion: 0,
    streamEventLeague: 0,
    streamEventID: 0,
    streamSignalRView: "",
    streamRequestUrl: null,
    // Funkcia nastavenia parametrov streamu - sport, region, liga, event
    streamSetEventParameters: (streamSportID, streamRegionID, streamLeagueID, streamEventID) => {
        stream.streamEventSport = streamSportID;
        stream.streamEventRegion = streamRegionID;
        stream.streamEventLeague = streamLeagueID;
        stream.streamEventID = streamEventID;
        if (stream.streamEventSport && stream.streamEventRegion && stream.streamEventLeague && stream.streamEventID) {
            // streamSignalRView pre pocuvanie zmien zapasu ktore prichadzaju cez 'RefreshView' signalR event
            stream.streamSignalRView = "S_" + stream.streamEventSport + "_R_" + stream.streamEventRegion + "_L_" + stream.streamEventLeague + "_LIVE";
            // streamRequestUrl na dopytovanie ponuky na pozadi (pokial je zobrazeny stream a zaroven sa zobrazuje ina ponuka)
            stream.streamRequestUrl = resolveOfferURL(url.offer + "OfferList/SportEvent/" + offer.sportEventID
                + "/Sport/" + stream.streamEventSport
                + "/Region/" + stream.streamEventRegion
                + "/LeagueCup/" + stream.streamEventLeague
                + "/Live/" + offer.onlyLive
                + "/Date/" + offer.date
                + "/Zone/" + offer.zone
                + "/Top/" + offer.top
                + "/LanguageID/" + offer.lang);
        } else {
            stream.streamSignalRView = "";
            stream.streamRequestUrl = null;
        }
    },
    streamStart: () => {
        stream.isStreamPlaying = true;
        // Ak je zapnuty zvuk a StreamAdjustVolume je vacsi ako aktualna hlasitost, tak sa nastavi StreamAdjustVolume hlasitost
        // Aktualne stream funguje bez zvuku, preto je tato cast zakomentovana
        // if (profile.HaveSound) {
        //     if (profile.CurrentVolume < profile.StreamAdjustVolume) {
        //         more.volume.setVolume(profile.StreamAdjustVolume);
        //     }
        // }
    },
    streamEnd: () => {
        // Stream bol ukonceny - vycisti parametre streamu
        stream.isStreamPlaying = false;
        stream.streamSetEventParameters(0, 0, 0, 0);
        communication.topScreen('stream', {});
    },
    getStreamData: async () => {
        try {
            // Spravi request na ziskanie credentials pre stream
            var player = stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID ? "?playerId=" + stored.PlayerID : "";
            var response = await fetch(url.centralSB + '/sportbox/event-stream-info/' + offer.eventID + player);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return await response.json();
        } catch (e) {
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.createLog(2, "CentralSportboxEventStreamInfo_Failed", "error: " + e);
            console.error('getStreamData error:', e);
            return null;
        }
    },
    // Funkcia dopytuje ponuku, vrati ci sa aktivny stream zapas skoncil
    isStreamFinished: async () => {
        try {
            if (!stream.streamRequestUrl) {
                return true;
            }
            const response = await fetch(stream.streamRequestUrl);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            const offerBook = await response.json();
            return stream.isConditionForStreamEnd(offerBook);
        } catch (e) {
            stream.streamEnd();
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.createLog(2, "isStreamFinished_Failed", "offerBook request: " + stream.streamRequestUrl + " error: " + e);
            console.error('isStreamFinished error:', e);
            return true;
        }
    },
    isConditionForStreamEnd: (offerBook) => {
        var isStreamEnded = true;
        if (offerBook && !offerBook.ErrorType && offerBook.EventChanceTypes && offerBook.EventChanceTypes.length) {
            isStreamEnded = !offerBook.EventChanceTypes.some((eChanceType) => {
                return stream.streamEventID === eChanceType.EventID;
            });
        }
        return isStreamEnded;
    },
    isActualOfferDifferentAsStream: () => {
        return (offer.sportID !== stream.streamEventSport) ||
            (offer.regionID !== -1 && offer.regionID !== stream.streamEventRegion) ||
            (offer.leagueCupID !== -1 && offer.leagueCupID !== stream.streamEventLeague);
    },
    // Zisti ci sa zobrazovany stream nachadza v ponuke, ak nie, tak sa ukonci stream
    closeStreamIfFinished: async () => {
        console.log('closeStreamIfFinished');
        var isStreamEnded = await stream.isStreamFinished();
        if (isStreamEnded) {
            console.log('stream was ended, closing stream');
            stream.streamEnd();
        }
    }
};